export default __webpack_public_path__ + "static/media/ty-860x573.f7048316.jpg";